module.exports = __webpack_public_path__ + "img/contact-us-close-button-circle.c267a546.png";